export enum PlanStepPage {
  StrategyMap,
  AnnualPlan,
  ImplementationPlan,
  TheoryOfAction
}
